export { default, CompanyLogoSize } from './CompanyLogo';
